export default 
[
  {
    id: 0,
    nome: 'Gestora'
  },
  {
    id: 1,
    nome: 'Boleto'
  },
  {
    id: 2,
    nome: 'Dep.cheque'
  },
  {
    id: 3,
    nome: 'Carta déb.transf.'
  },
  {
    id: 4,
    nome: 'Carta déb.'
  },
  {
    id: 5,
    nome: 'Boleto cheque'
  },
  {
    id: 6,
    nome: 'Ordem pgto'
  },
  {
    id: 7,
    nome: 'Pgto eletrônico'
  },
  {
    id: 8,
    nome: 'Invoice'
  },
]



// WEBPACK FOOTER //
// ./FrontEnd/js/formas-pagamento-transferencia.js